import axios from 'axios';

export interface ReplyMessage {
  id: string;
  originalMessageId: string;
  userMessage: string;
  timestamp: string;
}

/**
 * Mock API for submitting a reply to a message
 * In a real application, this would send the reply to your backend
 */
export const submitReply = async (
  chatId: string | undefined,
  replyingToMessageId: string,
  userMessage: string,
  userId?: string
): Promise<ReplyMessage> => {
  try {
    // Mock delay to simulate network request
    await new Promise(resolve => setTimeout(resolve, 300));

    // In a real app, you would make an actual API call like:
    // const response = await axios.post('/api/messages/reply', {
    //   chatId,
    //   originalMessageId: replyingToMessageId,
    //   message: userMessage,
    //   userId
    // });
    // return response.data;

    // Mock response
    const mockReply: ReplyMessage = {
      id: `reply_${Date.now()}`,
      originalMessageId: replyingToMessageId,
      userMessage,
      timestamp: new Date().toISOString(),
    };

    return mockReply;
  } catch (error) {
    throw error;
  }
};

/**
 * Get all replies for a specific message
 * Mock implementation
 */
export const getRepliesForMessage = async (
  chatId: string | undefined,
  messageId: string
): Promise<ReplyMessage[]> => {
  try {
    // Mock delay
    await new Promise(resolve => setTimeout(resolve, 200));

    // In a real app:
    // const response = await axios.get(`/api/messages/${messageId}/replies?chatId=${chatId}`);
    // return response.data;

    return [];
  } catch (error) {
    throw error;
  }
};

/**
 * Update a reply
 * Mock implementation
 */
export const updateReply = async (
  chatId: string | undefined,
  replyId: string,
  updatedMessage: string
): Promise<ReplyMessage> => {
  try {
    // Mock delay
    await new Promise(resolve => setTimeout(resolve, 300));

    // In a real app:
    // const response = await axios.patch(`/api/messages/replies/${replyId}`, {
    //   chatId,
    //   message: updatedMessage
    // });
    // return response.data;

    // Mock response
    const mockReply: ReplyMessage = {
      id: replyId,
      originalMessageId: '',
      userMessage: updatedMessage,
      timestamp: new Date().toISOString(),
    };

    return mockReply;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a reply
 * Mock implementation
 */
export const deleteReply = async (
  chatId: string | undefined,
  replyId: string
): Promise<void> => {
  try {
    // Mock delay
    await new Promise(resolve => setTimeout(resolve, 300));

    // In a real app:
    // await axios.delete(`/api/messages/replies/${replyId}`, {
    //   params: { chatId }
    // });
  } catch (error) {
    throw error;
  }
};

// Store reply linkage locally (mock backend)
export interface ReplyLinkRecord {
  chatId: string;
  messageId: string;
  replyToId: string;
  createdAt: string;
}

export const saveReplyLinkMock = async (link: ReplyLinkRecord): Promise<ReplyLinkRecord> => {
  try {
    const key = "reply_links";
    const raw = typeof localStorage !== "undefined" ? localStorage.getItem(key) : null;
    const arr: ReplyLinkRecord[] = raw ? JSON.parse(raw) : [];
    arr.push(link);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(key, JSON.stringify(arr));
    }
    return link;
  } catch {
    return link;
  }
};
